import styled from "styled-components";
import { ReactComponent as FedeTommi } from "../media/Fedetommi-min.svg";
import { GeneralText } from "./GeneralText";
import { useTranslation } from "react-i18next";
import { namespaces } from "../i18n.costants";
import { AnchorHTMLAttributes } from "react";
import { ReactComponent as Instagram } from "../media/instagram.svg";
import { ReactComponent as Facebook } from "../media/facebook.svg";

export function Footer() {
  const { t } = useTranslation(namespaces.common);
  const currentYear = new Date().getFullYear();

  return (
    <Wrapper>
      <ContentContainer>
        <div>
          <GeneralText>Via Contarina 11b</GeneralText>
          <GeneralText>37134 Verona VR, {t("Italia")}</GeneralText>
          <GeneralText>VEV SERVIZI SRL P.IVA 04964560231</GeneralText>
          <br />
        </div>
        <div>
          <GeneralText>
            Tel: <Link href="tel:+393898836147">+39&nbsp;389&nbsp;8836147</Link>
          </GeneralText>
          <GeneralText>
            Email:{" "}
            <Link href="mailto:vevservizisrl@gmail.com">
              vevservizisrl@gmail.com
            </Link>
          </GeneralText>
          <br />
        </div>
        <div>
          <SocialMedia>
            <IconContainer
              href="https://www.facebook.com/share/19ghmFUm7S"
              title="Facebook"
            >
              <Facebook />
            </IconContainer>
            <IconContainer href="https://www.instagram.com/" title="Instagram">
              <Instagram />
            </IconContainer>
          </SocialMedia>
          <br />
          <Copyright>
            {`© ${currentYear} VEV SERVIZI SRL -`}
            <Link>
              <FedeTommi height={20} fill="white" />
            </Link>
          </Copyright>
        </div>
      </ContentContainer>
    </Wrapper>
  );
}

const Wrapper = styled.footer`
  grid-column: 1 / -1;
  background: var(--color-blue-gradient);
  color: var(--color-gray-transparent);
  z-index: 1;

  @media (max-width: 1300px) {
    div {
      text-align: center;
      margin: auto;
      width: fit-content;
      justify-content: center;
    }
  }
`;
const ContentContainer = styled(GeneralText)`
  width: 100%;
  max-width: var(--content-width);
  margin: auto;
  padding: 100px 0 80px;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 1300px) {
    padding: 50px 20px 100px 20px;
    grid-template-columns: 1fr;
    max-width: 100%;
  }
`;
const Copyright = styled(GeneralText)`
  color: white;
  display: flex;
  flex-direction: row;
  gap: 6px;
  flex-wrap: wrap;
`;
const Link = styled.a<AnchorHTMLAttributes<HTMLAnchorElement>>`
  color: var(--color-gray-transparent);
`;
const IconContainer = styled.a<AnchorHTMLAttributes<HTMLAnchorElement>>`
  width: 22px;
  height: 22px;
`;
const SocialMedia = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: auto;
`;
